"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Environment_1 = __importDefault(require("../BusinessLogicLayer/Environment"));
const apiType_1 = require("../apiType");
const Environment_2 = __importDefault(require("../ApiLayers/Mock/Environment/Environment"));
const CLConnectMock_1 = __importDefault(require("../ApiLayers/CLConnect/CLConnectMock"));
const Environment_3 = __importDefault(require("../ApiLayers/PBP10/Environment/Environment"));
const http_client_1 = require("@almservices-cl/http-client");
const assertPBPProductionHost_1 = __importDefault(require("../Util/assertPBPProductionHost"));
const http_client_2 = require("@almservices-cl/http-client");
const logger_1 = require("@almservices-cl/logger");
const environmentApiFactory = (typeValue, host) => {
    (0, assertPBPProductionHost_1.default)(typeValue, host);
    switch (typeValue) {
        case apiType_1.apiType.MOCK:
            return new Environment_2.default();
        case apiType_1.apiType.CL_CONNECT:
            return new CLConnectMock_1.default();
        case apiType_1.apiType.PBP_10:
            return new Environment_3.default(new http_client_1.PBP10Client(new http_client_2.PBP10RequestExecutor(host || "", new logger_1.ConsoleLogger("ENV")), new logger_1.ConsoleLogger("ENV"), "", ""));
    }
};
// to use EnvironmentClient you can not use container
exports.default = (typeValue, host) => {
    return new Environment_1.default(environmentApiFactory(typeValue, host));
};
//# sourceMappingURL=EnvironmentType.js.map